import API_URL from "../../utils/apiUrl";

const TOKEN_KEY = "master_token";

export const masterAuth = {
  saveToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  getToken: () => localStorage.getItem(TOKEN_KEY),
  clear: () => localStorage.removeItem(TOKEN_KEY),
  isLoggedIn: () => !!localStorage.getItem(TOKEN_KEY),
};

export async function masterFetch(path, opts = {}) {
  return masterFetchAbs(`/api/master${path}`, opts);
}

export async function masterFetchAbs(fullPath, opts = {}) {
  const token = masterAuth.getToken();
  const res = await fetch(`${API_URL}${fullPath}`, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(opts.headers || {}),
    },
  });
  if (res.status === 401 || res.status === 403) {
    masterAuth.clear();
    window.location.href = "/master/login";
    throw new Error("auth");
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}
